import dateFormatter from "../../mixins/dateFormatter";

export default {
    methods: {
        columnTemplates(timezone) {
            return {
                created_at(h, row) {
                    return dateFormatter.methods.dateSmall(row.created_at, timezone)
                },
                launch(h, row) {
                    return !!row.launch ? dateFormatter.methods.dateSmall(row.launch, timezone) : 'Not Scheduled';
                },
                subscribers_count(h, row) {
                    return row.subscribers_count === 0 ? 'None' : row.subscribers_count;
                },
                contact(h, row) {
                    return !!row.contact.name ? row.contact.name : 'Visitor'
                },
                initiated_at(h, row) {
                    return dateFormatter.methods.dateMedium(row.initiated_at, timezone)
                },
                finished_at(h, row) {
                    return row.finished_at ? dateFormatter.methods.dateMedium(row.finished_at, timezone) : ''
                }
            }
        }
    }
}
